import { render, staticRenderFns } from "./UserPasswordHistories.vue?vue&type=template&id=2eb66584"
import script from "./UserPasswordHistories.vue?vue&type=script&lang=js"
export * from "./UserPasswordHistories.vue?vue&type=script&lang=js"
import style0 from "./UserPasswordHistories.vue?vue&type=style&index=0&id=2eb66584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports